import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CookieCategory from './CookieCategory';
import { existCookie, encodeCookieList, setCookie } from '../../services/cookies';

import '../../static/less/cookie_banner.less';

class CookieBanner extends React.Component {
  constructor(props) {
    super(props);
    // Binding Funcs
    this.toggleCategoriesSection = this.toggleCategoriesSection.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.loadCategoriesData = this.loadCategoriesData.bind(this);
    this.setSelectedCookies = this.setSelectedCookies.bind(this);
    // Vars
    this.state = {
      showCategories: false,
      showBanner: this.needToShowBanner(),
      cookieCategories: undefined,
    };
  }

  componentDidMount() {
    if (this.state.cookieCategories === undefined) this.loadCategoriesData();
  }

  // --- Getters
  getEncodedCookieList(selectedCookies) {
    return encodeCookieList(selectedCookies);
  }

  needToShowBanner() {
    const cookieAgreed = existCookie('cookie-agreed');
    return !cookieAgreed;
  }

  canIShowBanner() {
    const { cookieCategories, showBanner } = this.state;
    if (!showBanner) return false;
    if (cookieCategories === undefined) return false;
    return this.needToShowBanner();
  }

  // --- Setters
  toggleCategoriesSection() {
    this.setState({ showCategories: !this.state.showCategories });
  }

  handleCategoryChange(catId) {
    const cookieCategories = this.state.cookieCategories.slice();
    const index = cookieCategories.findIndex((cat) => cat.id === catId);
    const cat = cookieCategories[index];
    if (cat.required) {
      return;
    }
    cookieCategories[index] = { ...cat, checked: !cat.checked };
    this.setState({ cookieCategories });
  }

  loadCategoriesData() {
    const data = [
      {
        cat: 'analysis',
        id: 'analysis_cookies',
        checked: true,
        required: false,
      },
      {
        cat: 'advertising',
        id: 'advertising_cookies',
        checked: true,
        required: false,
      },
      {
        cat: 'personalization',
        id: 'personalization_cookies_',
        checked: true,
        required: false,
      },
      {
        cat: 'compulsory',
        id: 'compulsory_cookies',
        checked: true,
        required: true,
      },
    ];
    this.setState({ cookieCategories: data });
  }

  setSelectedCookies(all = false) {
    const { cookieCategories } = this.state;
    let selectedCookies;
    if (all) {
      selectedCookies = cookieCategories.map((cat) => cat.id);
    } else {
      selectedCookies = cookieCategories.filter((cat) => cat.checked).map((cat) => cat.id);
    }

    const expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + 100);

    const hasSelectedCookies = selectedCookies.length > 0;
    if (hasSelectedCookies) {
      const cookiesString = this.getEncodedCookieList(selectedCookies);
      setCookie('cookie-agreed-categories', cookiesString, expireDate);
    }
    const cookieAgreedVal = hasSelectedCookies ? '2' : '0';
    setCookie('cookie-agreed', cookieAgreedVal, expireDate);
    this.setState({ showBanner: false });
  }

  // --- Renders
  renderPopUpText() {
    return (
      <div id='popup-text'>
        <p>
          {this.context.t('We use cookies to personalize content and ads, improve your user experience, and to analyze our traffic.')}
          {this.context.t('We also share information about your use of our website with our social media, advertising, and analytics partners.')}
          {this.context.t('Continue if you agree, or read more about our use of cookies here.')}
        </p>
      </div>
    );
  }

  renderCategories() {
    const { showCategories, cookieCategories } = this.state;
    return (
      <div id='eu-cookie-compliance-categories' className={showCategories ? '' : 'hide'}>
        <button id="close-category" aria-label='Close' onClick={this.toggleCategoriesSection}/>
        { cookieCategories.map(
          (cat) => <CookieCategory cat={cat} catChange={(id) => this.handleCategoryChange(id)} key={cat.id} />)}
        <div className='eu-cookie-compliance-categories-buttons'>
          <button className='blue-style' onClick={() => this.setSelectedCookies()}>
            {this.context.t('Apply')}
        </button>
        </div>
      </div>
    );
  }

  renderButtons() {
    const { chainData, lang } = this.props;
    const moreInfoUrl = chainData.booking_engine_configuration[`terms_and_conditions_url_${lang}`];
    return (
      <div id='popup-buttons' className='eu-cookie-compliance-buttons'>
        <button className='configure-button white-style'
          onClick={this.toggleCategoriesSection}>
          {this.context.t('Configure')}
        </button>
        <a href={moreInfoUrl} target="_blank" rel="noreferrer">
          <button className='white-style underline'>
            {this.context.t('More info')}
          </button>
        </a>
        <button className='agree-button blue-style' onClick={() => this.setSelectedCookies(true)}>
          {this.context.t('Ok, I agree')}
        </button>
      </div>
    );
  }

  render() {
    if (!this.canIShowBanner()) return null;
    return (
      <div id='sliding-popup'>
        <div id='eu-cookie-compliance-banner'>
          <div className='container'>
            <div id='eu-cookie-compliance-content'>
              {this.renderPopUpText()}
              {this.renderCategories()}
              {this.renderButtons()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CookieBanner.propTypes = {
  lang: PropTypes.string.isRequired,
};

CookieBanner.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  chainData: state.session.chainData,
}))(CookieBanner);
